module.exports = __webpack_public_path__ + "static/media/8.4429eda6.png";